import request from '../utils/request'

export function fetchCatalogFileList(data) {
  return request({
    url: '/api/catalog/file/list',
    method: 'post',
    data,
  })
}

export function createCatalogRequest(data) {
  return request({
    url: '/api/catalog/request/create',
    method: 'post',
    data,
  })
}

export function fetchCatalogConfig() {
  return request({
    url: '/api/catalog/config/get',
    method: 'post',
    data: {},
  })
}
